// src/app/services/config.service.ts
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
    categoryImageUrl: string;
    vendorImageUrl: string;
    sideNavProfileImage: string;
    imageUrl: string;
    posApi: string;
    badgesImageUrl: string;
  
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ){}

  getConfig(): Observable<any> {
    let currentHost = window.location.hostname;
    if (isPlatformBrowser(this.platformId)) {
      // Running in the browser
      currentHost = window.location.hostname;
    } else {
      // Running on the server
      currentHost = environment.serverRequestUrl;    
    }
    const DomainName = currentHost.split('.')[0];
    
    if (DomainName === 'localhost' || DomainName === 'www') {
      this.categoryImageUrl = environment.RX_URL_SCHEMA + "://" + environment.RX_BASE_DEV_SITE + "/files/category_image/";
      this.vendorImageUrl = environment.RX_URL_SCHEMA + "://" + environment.RX_BASE_DEV_SITE + "/files/vendor_image/";
      this.sideNavProfileImage = environment.RX_URL_SCHEMA + "://" + environment.RX_BASE_DEV_SITE + "/files/profile_image/";
      this.badgesImageUrl = environment.RX_URL_SCHEMA + "://" + environment.RX_BASE_DEV_SITE + "/files/badge_image/";
      this.imageUrl = environment.RX_URL_SCHEMA + "://" + environment.RX_BASE_DEV_SITE + "/files/product_image/";
      this.posApi = environment.RX_URL_SCHEMA + "://" + environment.RX_BASE_DEV_SITE + "/api/";
    } else {
      this.categoryImageUrl = environment.RX_URL_SCHEMA + "://" + currentHost + "/images/category_image/";
      this.vendorImageUrl = environment.RX_URL_SCHEMA + "://" + currentHost + "/images/vendor_image/";
      this.badgesImageUrl = environment.RX_URL_SCHEMA + "://" + currentHost + "/images/badge_image/";
      this.sideNavProfileImage = environment.RX_URL_SCHEMA + "://" + currentHost + "/images/profile_image/";
      this.imageUrl = environment.RX_URL_SCHEMA + "://" + currentHost + "/images/product_image/";
      this.posApi = environment.RX_URL_SCHEMA + "://" + currentHost + "/api/";
      if(environment.RX_CDN_URL){ 
        this.badgesImageUrl = environment.RX_CDN_URL + "/files/badge_image/";
        this.categoryImageUrl = environment.RX_CDN_URL + "/files/category_image/";
        this.vendorImageUrl = environment.RX_CDN_URL + "/files/vendor_image/";
        this.imageUrl = environment.RX_CDN_URL + "/files/product_image/";
      }
    }

    const config = {
        categoryImageUrl: this.categoryImageUrl,
        vendorImageUrl: this.vendorImageUrl,
        badgesImageUrl: this.badgesImageUrl,
        sideNavProfileImage: this.sideNavProfileImage,
        imageUrl:this.imageUrl,
        posApi: this.posApi,
    };
    return of(config); // Return an Observable of the config object
  }
}